
import { handleSecureForm, handleAgentJoinEvent, handleAgentJoinConferenceEvent, handleAgentLeaveEvent, handleAgentLeftConferenceEvent,  handleAgentTransferEvent, handleQueuePositionEvent, handleChatEndEvent, handleChatSessionExpire, handleChatInputFieldEnable, signInPill, handleCSATSubmitEvent, signOutPill, handleGenericInfoEvent, showTermsAndConditionAcceptMessage } from './eventInfo'

export default {
  INFO_PILL: {
    AGENT_EVENT: {
      SIGNIN: signInPill,
      JOIN: handleAgentJoinEvent,
      AGENT_JOIN_CONFERENCE: handleAgentJoinConferenceEvent,
      LEAVE: handleAgentLeaveEvent,
      AGENT_LEFT_CONFERENCE: handleAgentLeftConferenceEvent,
      TRANSFER: handleAgentTransferEvent
    },
    QUEUE_POSITION: {
      WAIT: handleQueuePositionEvent
    },
    GENERIC: {
      GENERIC_INFO: handleGenericInfoEvent
    },
    OAUTH: {
      SIGN_OUT: signOutPill,
      SIGN_IN: signInPill
    },
    WIDGET_EVENT: {
      CHAT_END: handleChatEndEvent,
      SESSION_EXPIRE: handleChatSessionExpire,
      TERMS_AND_CONDITION_ACCEPTED: showTermsAndConditionAcceptMessage
    },
    CSAT_SURVEY: {
      SUBMIT: handleCSATSubmitEvent
    }
  },
  INFO: {
    ENABLE_INPUT_FIELD: {
      ENABLE_CHAT_INPUT_FIELD: handleChatInputFieldEnable
    },
    SECURE_FORM: {
      CARD_INFO: handleSecureForm,
      LINK_GENERATION: handleSecureForm,
      SECURE_LINK: handleSecureForm,
      FORM_STATUS: handleSecureForm
    }
  }
}
